if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: false,
			numberFilterTree: 2,
			selectOptionContainer: '.grid__item .card-wrapper',
			stickyFixTopPos: true
		},
		selector: {
			otpTopCartCount: '.cart-count-bubble'
		}
	};
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card Product Form By Status
		var type = '';

		itemHtml = itemHtml.replace(/{{productCard}}/g, boostPFSTemplate.productCard);

		// Add QuickView Button
		itemHtml = itemHtml.replace(/{{qvButton}}/g, buildQVButton(data));
		itemHtml = itemHtml.replace(/{{qvModal}}/g, buildQVModal(data));

		itemHtml = itemHtml.replace(/{{productDescription}}/g, buildProductDescription(data));

		// Add Card product ID
		itemHtml = itemHtml.replace(/{{productID}}/g, buildProductID(data));
		// Add Card product Vendor
		itemHtml = itemHtml.replace(/{{productVendor}}/g, buildProductVendor(data));
		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());

		itemHtml = itemHtml.replace(/{{customBadges}}/g, buildCustomLabels(data));
		// Add Images
		// itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Image background
		itemHtml = itemHtml.replace(/{{productImageUrl}}/g, buildImageBG(data));
		itemHtml = itemHtml.replace(/{{productImageUrlSecond}}/g, buildImageBG2(data));

		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		itemHtml = itemHtml.replace(/{{itemPriceQV}}/g, buildPriceQV(data));

		itemHtml = itemHtml.replace(/{{productPrice}}/g, buildProductPrice(data));
		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemID}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if (this.index == 4) itemHtml += boostPFSTemplate.bannerHtml;

		return itemHtml;
	};

	function buildVariants(data, type){
		var html = ``;

		var options = data.options_with_values;

		html += `<variant-radios class="no-js-hidden d-none d-xl-block" data-section="template--${data.id}__main${type}" data-url="/products/${data.handle}" data-update-url="false">`;

		options.forEach((option, option_index) => {

			option_index = option_index + 1;
			if(option.label !== 'Title'){
				if(option.values.length > 0 && type != '_qv'){
					html += `
					<fieldset class="dropdown mb-3" data-selected="${option.values[0].title}">
					  <button class="btn btn-secondary-outline-black dropdown-toggle w-100" type="button" id="dropdownMenuButton-${data.id}-${option_index}" data-bs-toggle="dropdown" aria-expanded="false">
					    ${option.label}
					  </button>
					  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton-${data.id}-${option_index}">`;
						option.values.forEach((value, value_index) => {
							html += `<li><button type="button" class="dropdown-item" id="template--${data.id}__main${type}-${option_index}-${value_index}" data-value="${value.title}">${value.title}</button></li>`;
						});
					html += `</ul>
					</fieldset>
					`;
				} else {
					html += `<p class="form__label mb-2">${option.label}</p>`;
					html += `<fieldset class="js product-form__input values-${option.values.length} mb-3">`;
					option.values.forEach((value, value_index) => {
						html += `<input type="radio" id="template--${data.id}__main${type}-${option_index}-${value_index}" name="${option.label}" value="${value.title}" form="product-form-template--${data.id}__main${type}" ${value_index == 0 ? 'checked' : ''}>`;
						html += `<label for="template--${data.id}__main${type}-${option_index}-${value_index}">${processLabel(value.title)}</label>`;
					})
					html += `</fieldset>`;
				}
			}


		});

		html += `<script type="application/json">${JSON.stringify(data.variants)}</script>`;
		html += `</variant-radios>`;

		return html;
	}

	function buildProductDescription(data){
		var html = `<div class="description">${data.description}</div>`;
		return html;
	}

	function processLabel(title){

		var title = title;

		switch (title) {
			case '2X-Small':
				title = '2XS'
				break;
			case 'X-Small':
				title = 'XS'
				break;
		  case 'Small':
		    title = 'S'
		    break;
			case 'Medium':
				title = 'M'
				break;
			case 'Large':
				title = 'L'
				break;
			case 'X-Large':
				title = 'XL'
				break;
			case '2X-Large':
				title = '2XL'
				break;
			case '3X-Large':
				title = '3XL'
				break;
			case '4X-Large':
				title = '4XL'
				break;
			case '5X-Large':
				title = '5XL'
				break;
		  default:
		    title = title
		};

		return title;
	}

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/


	function buildImageBG(data){

		var extension = ''
		if(data.images[1].includes('.jpg')) extension = '.jpg'
		if(data.images[1].includes('.png')) extension = '.png'
		if(data.images[1].includes('.gif')) extension = '.gif'

		var image_split = data.images[1].split(extension);
		var final_image = image_split[0] + '_325x' + extension + image_split[1];

		return final_image;
	}

	function buildImageBG2(data){

		html = '';
		if(data.images[2]){

			var extension = ''
			if(data.images[2].includes('.jpg')) extension = '.jpg'
			if(data.images[2].includes('.png')) extension = '.png'
			if(data.images[2].includes('.gif')) extension = '.gif'

			var image_split = data.images[2].split(extension);
			var final_image = image_split[0] + '_325x' + extension + image_split[1];

			html += `
			<div class="square bg-cover item-image second-image bg-white" style="background-image:url(${final_image})">
				<div class="content"></div>
			</div>
			`
		}
		return html;
	}

	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = 1 / aspectRatio * 100;

			html += '<div';
			if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
				boostPFSThemeConfig.custom.add_image_padding === true) {
				html += ' class="card__media-full-spacer"';
			}
			html += '>';
			html += '<div class="media media--transparent media--';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
				html += boostPFSThemeConfig.custom.media_size;
			}
			html += ' media--hover-effect"';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
				boostPFSThemeConfig.custom.media_size == 'adapt' &&
				images.length > 0) {
				html += ' style="padding-bottom: ' + paddingBottom + '%"';
			}
			html += '>'
			html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].height + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			if (activeSwapImage) {
				html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + flipImageSrcSet + '" ' +
				'height="' + images[1].height + '" ' +
				'width="' + images[1].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			}
			html += '</div>';
			html += '</div>';
		} else {
			html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else if(boostPFSThemeConfig.custom.hasOwnProperty('show_image_outline') && boostPFSThemeConfig.custom.show_image_outline){
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildQVButton(data){
		var product_form_id = 'section-collection' + '-' + data.id;
		var html = '';
		html += `
		<modal-opener data-modal="#QuickAdd-${data.id}">
			<button
				id="${product_form_id}-submit"
				type="submit"
				name="add"
				class="quick-add__submit btn btn-tertiary text-center"
				aria-haspopup="dialog"
				aria-labelledby="${product_form_id}-submit title-${product_form_id}"
				data-product-url="/products/${data.handle}"
			>
				Quick View
				<div class="loading-overlay__spinner hidden">
					<svg
						aria-hidden="true"
						focusable="false"
						class="spinner"
						viewBox="0 0 66 66"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
			</button>
		</modal-opener>
		`;

		return html;

	}

	function buildQVModal(data){
		var product_form_id = 'section-collection' + '-' + data.id;
		var html = '';
		html += `
		<quick-add-modal id="QuickAdd-${data.id}" class="quick-add-modal">
			<div
				role="dialog"
				aria-label="{{ 'products.product.choose_product_options' | t: product_name: card_product.title | escape }}"
				aria-modal="true"
				class="quick-add-modal__content global-settings-popup"
				tabindex="-1"
			>
				<button
					id="ModalClose-${data.id}"
					type="button"
					class="quick-add-modal__toggle"
					aria-label="{{ 'accessibility.close' | t }}"
				>
					<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M16.1825 18.0001L12.5465 14.3641C12.3123 14.1216 12.1827 13.7968 12.1856 13.4597C12.1885 13.1226 12.3237 12.8001 12.5621 12.5617C12.8005 12.3234 13.123 12.1881 13.4601 12.1852C13.7972 12.1823 14.122 12.3119 14.3645 12.5461L18.0005 16.1821L21.6365 12.5461C21.7551 12.4233 21.8969 12.3253 22.0538 12.2579C22.2107 12.1906 22.3794 12.1551 22.5501 12.1536C22.7208 12.1521 22.8901 12.1847 23.0481 12.2493C23.2061 12.314 23.3497 12.4094 23.4704 12.5301C23.5911 12.6509 23.6866 12.7944 23.7512 12.9524C23.8159 13.1104 23.8484 13.2797 23.8469 13.4505C23.8454 13.6212 23.81 13.7899 23.7426 13.9467C23.6752 14.1036 23.5773 14.2455 23.4545 14.3641L19.8185 18.0001L23.4545 21.6361C23.5773 21.7547 23.6752 21.8966 23.7426 22.0534C23.81 22.2103 23.8454 22.379 23.8469 22.5497C23.8484 22.7204 23.8159 22.8897 23.7512 23.0477C23.6866 23.2057 23.5911 23.3493 23.4704 23.47C23.3497 23.5907 23.2061 23.6862 23.0481 23.7508C22.8901 23.8155 22.7208 23.848 22.5501 23.8465C22.3794 23.8451 22.2107 23.8096 22.0538 23.7422C21.8969 23.6748 21.7551 23.5769 21.6365 23.4541L18.0005 19.8181L14.3645 23.4541C14.122 23.6883 13.7972 23.8179 13.4601 23.8149C13.123 23.812 12.8005 23.6768 12.5621 23.4384C12.3237 23.2 12.1885 22.8776 12.1856 22.5405C12.1827 22.2033 12.3123 21.8786 12.5465 21.6361L16.1825 18.0001Z" fill="black"/>
						<path d="M18 33.4286C20.0261 33.4286 22.0324 33.0295 23.9043 32.2541C25.7761 31.4788 27.477 30.3423 28.9096 28.9096C30.3423 27.477 31.4788 25.7761 32.2541 23.9043C33.0295 22.0324 33.4286 20.0261 33.4286 18C33.4286 15.9739 33.0295 13.9676 32.2541 12.0957C31.4788 10.2239 30.3423 8.52303 28.9096 7.09035C27.477 5.65768 25.7761 4.52122 23.9043 3.74586C22.0324 2.9705 20.0261 2.57143 18 2.57143C13.9081 2.57143 9.98377 4.19693 7.09035 7.09035C4.19693 9.98377 2.57143 13.9081 2.57143 18C2.57143 22.0919 4.19693 26.0162 7.09035 28.9096C9.98377 31.8031 13.9081 33.4286 18 33.4286ZM18 36C13.2261 36 8.64773 34.1036 5.27208 30.7279C1.89642 27.3523 0 22.7739 0 18C0 13.2261 1.89642 8.64773 5.27208 5.27208C8.64773 1.89642 13.2261 0 18 0C22.7739 0 27.3523 1.89642 30.7279 5.27208C34.1036 8.64773 36 13.2261 36 18C36 22.7739 34.1036 27.3523 30.7279 30.7279C27.3523 34.1036 22.7739 36 18 36Z" fill="black"/>
					</svg>
				</button>
				<div id="QuickAddInfo-${data.id}" class="quick-add-modal__content-info"></div>
			</div>
		</quick-add-modal>
		`;

		return html;

	}

	function buildProductID(data) {
		return data.id;
	}

	function buildProductVendor(data) {
		return data.vendor;
	}

	function buildProductPrice(data) {
		return data.price_min;
	}

	function slideImages(data, type) {

		var html = ``;

		if(type == 'images'){
			Object.values(data.images).forEach((image, i) => {
				html += `
				<div class="slide mb-md-3">
				  <div class="slide-nav-button square bg-contain ${i === 0 ? 'border' : ''}" style="background-image:url(${image})" data-slide-num="${(i + 1)}">
				    <div class="content"></div>
				  </div>
				</div>
				`;
			});
		} else {
			Object.values(data.images).forEach((image, i) => {
				html += `
				<div class="slide">
					<div class="square bg-contain" style="background-image:url(${image})">
						<div class="content"></div>
					</div>
				</div>
				`;
			});
		}

		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
		var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
			: priceAmount;
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''

		var sale_percentage = (data.compare_at_price_min - data.price_min) / data.compare_at_price_min * 100;

		html = `
		<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
					<div>
						<div class="price__regular">
							<span class="visually-hidden visually-hidden--inline">
								${boostPFSConfig.label.regular_price}
							</span>
							<span class="price-item price-item--regular">
								${moneyPrice}
							</span>
						</div>
						<div class="price__sale">

							<div class="sale-flag me-3">
								Save ${sale_percentage.toFixed(0)}%
							</div>

							<span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							<span class="price-item price-item--sale price-item--last">
								${moneyPrice}
							</span>

							<span class="visually-hidden visually-hidden--inline">
								${boostPFSConfig.label.regular_price}
							</span>
							<span>
								<s class="price-item price-item--regular">
									${compareAtPrice}
								</s>
							</span>

						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
							<span class="price-item price-item--last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</span>
					  </small>
					</div>
				</div>`;

		return html;
	}

	function buildPriceQV(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
		var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
			: priceAmount;
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''

		var sale_percentage = (data.compare_at_price_min - data.price_min) / data.compare_at_price_min * 100;

		html = `

		<div class="
    price price--large price--on-sale  price--show-badge ">
  <div class="price__container"><div class="price__regular">
      <span class="visually-hidden visually-hidden--inline">Regular price</span>
      <span class="h1 price-item price-item--regular price-item--sale">
        $42.00 CAD
      </span>
    </div>
    <div class="price__sale">
      <div class="d-flex flex-row">
        <div class="me-2" data-price="">
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
          <span class="h1 price-item price-item--sale price-item--last  price--main" data-currency-original="$42.00 CAD" data-currency-usd="$42.00 CAD" data-currency="CAD">
					${moneyPrice}
          </span>
        </div>
        <div class="d-flex flex-column justify-content-center saved-prices">
          <p class="small m-0 sale-flag"><span class="m-0 text-uppercase ">Save ${sale_percentage.toFixed(0)}%</span>
          </p>
          <p class="small m-0 price-item price-item--regular ">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span>${compareAtPrice}</span></p>
        </div>
      </div>
    </div>
    <small class="unit-price caption hidden">
      <span class="visually-hidden">Unit price</span>
      <span class="price-item price-item--last">
        <span></span>
        <span aria-hidden="true">/</span>
        <span class="visually-hidden">&nbsp;per&nbsp;</span>
        <span>
        </span>
      </span>
    </small>
  </div>
</div>
`;

		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function buildCustomLabels(data) {
		var badges = data.tags.filter(item => item.includes('badge_'));

		// Build Sale label
		var html = '';

		if(badges.length){
			badges.forEach(badge => {
				var badge_parts = badge.split(':');

				var badge_type = badge_parts[0];
				var badge_text = badge_parts[1];

				switch (badge_type) {
					case 'badge_sale':
						if(!badge_text){
							var badge_text = 'Sale'
						}
						html += '<span class="badge badge--bottom-left color-bg-sale">' + badge_text + '</span>'
						break;
				  default:
				    // console.log(`Sorry, we are out of ${badge_type}.`);
				}

			});
		}

		if(badges.length){
			badges.forEach(badge => {
				var badge_parts = badge.split(':');

				var badge_type = badge_parts[0];
				var badge_text = badge_parts[1];

				switch (badge_type) {
				  case 'badge_1':
				    html += '<span class="badge badge--bottom-left color-bg-primary">' + badge_text + '</span>'
				    break;
				  case 'badge_2':
						html += '<span class="badge badge--bottom-left color-bg-secondary">' + badge_text + '</span>'
						break;
				  case 'badge_3':
						html += '<span class="badge badge--bottom-left color-bg-tertiary">' + badge_text + '</span>'
						break;
				  default:
				    // console.log(`Sorry, we are out of ${badge_type}.`);
				}

			});
		}

		return html;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
	};

	/************************** END BUILD TOOLBAR **************************/
})();
